'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _neptune = require('./neptune');

var _neptune2 = _interopRequireDefault(_neptune);

var _n2 = require('./_n');

var _n3 = _interopRequireDefault(_n2);

var _formSerialize = require('../../node_modules/form-serialize');

var _formSerialize2 = _interopRequireDefault(_formSerialize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import fetch from '../../node_modules/unfetch'

_neptune2.default.cart = {};

// Handles all the things ajax cart related,
// based around the timber ajax cart, minus the jquery


_neptune2.default.cart.onCartUpdate = function (cart) {
  if (!cart.token) return false;
  window.cart = cart;
  _n3.default.trigger(document, 'cart:updated', false, true, cart);
};

_neptune2.default.cart.addItem = function (id, quantity, properties, callback) {
  _neptune2.default.cart.add({
    id: id,
    quantity: quantity,
    properties: properties
  }, callback);
};

_neptune2.default.cart.add = function (items, callback) {
  items = _n3.default.array(items).map(function (item) {
    var i = {
      id: item.id || item,
      quantity: item.quantity || 1,
      properties: item.properties || {}
    };
    if (!!i.properties['selling_plan']) {
      i.selling_plan = i.properties['selling_plan'];
      delete i.properties['selling_plan'];
    }
    return i;
  });
  items = items.filter(function (item) {
    return !!item.id;
  });
  if (!items.length) return false;
  _n3.default.trigger(document, 'cart:itemAdding', false, true);
  return fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items: _n3.default.array(items) })
  }).then(function (r) {
    return r.json();
  }).then(function (d) {
    if (!!d.status) {
      window.cart.error = d;
      _n3.default.trigger(document, 'cart:error', false, true, d);
    } else {
      if (typeof callback === 'function') {
        callback(d);
      }
      _neptune2.default.cart.getCart();
      _n3.default.trigger(document, 'cart:itemAdded', false, true, d);
    }

    // Neptune.cart.onCartUpdate(cart)
  });
};

_neptune2.default.cart.update = function (updates, callback) {

  if (_n3.default.empty(updates)) return false;

  return fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      updates: updates
    })
  }).then(function (r) {
    if (typeof callback === 'function') {
      callback(r.json());
    }
    _neptune2.default.cart.onCartUpdate(r.json());
  });
};

_neptune2.default.cart.change = function (change, callback) {

  if (_n3.default.empty(change)) return false;

  return fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(change)
  }).then(function (r) {
    if (typeof callback === 'function') {
      callback(r.json());
    }
    _neptune2.default.cart.getCart();
  });
};

_neptune2.default.cart.remove = function (remove, callback) {

  if ((typeof remove === 'undefined' ? 'undefined' : (0, _typeof3.default)(remove)) == 'object') {} else if (typeof remove == 'number' && remove < 1000) {
    // it's an index
    var u = {
      line: remove + 1,
      quantity: 0
    };
    console.log('remove by change', u);

    _neptune2.default.cart.change(u, callback);
  } else {
    // it's a variant id
    var u = {};
    _n3.default.array(remove).forEach(function (v) {
      u[v] = 0;
    });
    _neptune2.default.cart.update(u, callback);
  }
  return u;
};

_neptune2.default.cart.addItemFromForm = function (form, callback, errorCallback) {
  form = (0, _formSerialize2.default)(form, { hash: true });
  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(form)
  }).then(function (r) {
    if (typeof callback === 'function') {
      callback(r.json());
    } else {
      _neptune2.default.cart.onCartUpdate(r.json());
    }
  });
};

_neptune2.default.cart.getCart = function (callback) {
  return fetch('/cart.js', { credentials: 'include' }).then(function (r) {
    return r.json();
  }).then(function (cart) {
    if (typeof callback === 'function') {
      callback(cart);
    } else {
      _neptune2.default.cart.onCartUpdate(cart);
    }
  });
};

_neptune2.default.cart.changeItem = function (line, quantity, properties, callback) {
  var data = { line: line + 1, quantity: quantity, properties: properties || {} };
  fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (r) {
    return r.json();
  }).then(function (cart) {
    if (cart.status == 422) {
      _n3.default.qs('[neptune-message="cart"]').innerHTML = cart.description;
    } else {
      if (!!callback) {
        callback(cart);
      } else {
        _neptune2.default.cart.onCartUpdate(cart);
      }
    }
  });
};

_neptune2.default.cart.attributes = function (attributes, callback) {
  var data = { attributes: attributes };
  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (r) {
    return r.json();
  }).then(function (cart) {
    console.log('attribute update response', cart);
    if (cart.status == 422) {
      _n3.default.qs('[neptune-message="cart"]').innerHTML = cart.description;
    } else {
      if (!!callback) {
        callback(cart);
      } else {
        _neptune2.default.cart.onCartUpdate(cart);
      }
    }
  });
};

_neptune2.default.cart.attribute = function (key, val) {
  var data = cart.attributes || {};
  if (!!val) {
    data[key] = val;
  } else {
    if (data[key]) delete data[key];
  }
  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({ attributes: data }),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (r) {
    return r.json();
  }).then(function (cart) {
    console.log(cart);
  });
};

_neptune2.default.cart.note = function (note) {
  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({ note: note }),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (r) {
    return r.json();
  }).then(function (cart) {
    console.log(cart);
  });
};

window.Neptune = _neptune2.default;

exports.default = _neptune2.default.cart;